import { CheckPolicy, Resource } from '../../framework/permission-util'
import { RT } from '../permissions'
import Executive from '../../framework/rmi-util'
import { register } from '../../framework/rmi-server-util'
import { auditService } from './AuditTechnical'
import { AuditLogV2 } from './audit.entities'
import type { EntityType, AuditAction } from './audit.types'

export default class AuditExecutive extends Executive {

	initServer() {
	}

	/**
	 * Generic method to get changes for any entity since a specific date
	 */
	@CheckPolicy()
	async getEntityChangesSince(entityType: EntityType, entityId: string, sinceDate: Date): Promise<{
		changes: any[]
	}> {
		try {
			const result = await auditService.getChangesForEntitySince(entityType, entityId, sinceDate)
			
			return {
				changes: result.changes.map(change => ({
					id: change.id,
					createdAt: change.createdAt,
					userEmail: change.userEmail,
					userRole: change.userRole,
					action: change.action,
					changeSummary: change.changeSummary,
					changedFields: change.changedFields
				}))
			}
		} catch (error) {
			console.error(`Error getting ${entityType} changes since date:`, error)
			return {
				changes: []
			}
		}
	}

	/**
	 * Generic method to get recent changes for any entity since the user's last visit
	 */
	@CheckPolicy()
	async getEntityRecentChanges(entityType: EntityType, entityId: string): Promise<{
		changes: any[]
		lastVisit?: Date
		hasUnseenChanges: boolean
	}> {
		try {
			const result = await auditService.getRecentChangesForEntity(entityType, entityId)
			
			return {
				changes: result.changes.map(change => ({
					id: change.id,
					createdAt: change.createdAt,
					userEmail: change.userEmail,
					userRole: change.userRole,
					action: change.action,
					changeSummary: change.changeSummary,
					changedFields: change.changedFields
				})),
				lastVisit: result.lastVisit,
				hasUnseenChanges: result.changes.length > 0
			}
		} catch (error) {
			console.error(`Error getting ${entityType} recent changes:`, error)
			return {
				changes: [],
				hasUnseenChanges: false
			}
		}
	}

	/**
	 * Generic method to log page visits for any entity
	 */
	@CheckPolicy()
	async logEntityPageVisit(entityType: EntityType, entityId: string, route: string): Promise<void> {
		return await auditService.logPageVisit(entityType, entityId, route)
	}

	/**
	 * Generic method to create audit logs for any entity
	 */
	@CheckPolicy()
	async logEntityChange(
		entityType: EntityType,
		entityId: string,
		action: AuditAction,
		oldData?: any,
		newData?: any
	): Promise<AuditLogV2> {
		return await auditService.logEntityChange(entityType, entityId, action, oldData, newData)
	}
}

register(AuditExecutive) 